import React from 'react'

export function LayoutContainer (props) {
  const { children } = props

  return <section className="main-container">
    {children}
  </section>
}
